import React from 'react';

import classnames from 'classnames';

import './Button.scoped.scss';

// Reusable button, extends native button
// Example:

// <Button
//   onClick={save}
//   label="Reusable button"          // Label for button
//   colour="alternative-primary"     // Available colours: 'primary' | 'secondary' | 'alternative-primary' | 'none'
//   variant="outlined"               // Available variants: 'filled' | 'outlined' | 'decline'
//   fullWidth                        // Will make the button full width
//   startIcon={<Icon/>}              // React node to be used as icon
// />

interface Props {
  variant?: ButtonVariant;
  color?: ButtonColorVariant;
  fullWidth?: boolean;
  startIcon?: React.ReactNode;
  label: React.ReactNode;
}

const Button: React.FC<Props & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  variant = 'filled',
  label,
  fullWidth = false,
  startIcon,
  color = 'none',
  ...rest
}) => {
  return (
    <button
      className={classnames({
        'custom-button': true,
        [variant]: true,
        [color]: true,
        'full-width': fullWidth,
      })}
      {...rest}
    >
      {startIcon && <div className="start-icon">{startIcon}</div>}
      {label}
    </button>
  );
};

export default Button;
